<template>
  <b-modal
    id="bonus-cash-modal"
    hide-header
    centered
    size="sm"
    cancel-variant="outline-secondary"
    hide-footer
  >
    <div style="color: #000">
      <div
        class="d-flex flex-column justify-content-between align-items-center text-center"
      >
        <div class="dollar-icon">
          <span style="color: #27c281; font-size: 2rem; font-weight: 800"
            >$</span
          >
        </div>
        <p class="mb-1" style="font-size: 25px; font-weight: 800">BONUS CASH</p>
        <p style="font-size: 18px; font-weight: 500">Apply Bonus Cash</p>
        <p class="text-muted mt-1">
          This will immediately apply bonus cash to the user's account. You can
          adjust the bonus amount below.
        </p>
      </div>
      <div class="mt-2">
        <p class="font-weight-bold">Amount</p>
        <b-form-input
          v-model="amountBonus"
          placeholder="Enter bonus amount ($)"
        />
      </div>
      <div class="mt-1">
        <p class="font-weight-bold">Bonus Expired Days</p>
        <b-form-input
          v-model="bonusExpiredDays"
          placeholder="Enter day number"
        />
      </div>

      <div class="mt-2 d-flex justify-content-end">
        <b-button @click="closeModal" class="w-100">CANCEL</b-button>
        <b-button
          @click="handleApplyBonus"
          :disabled="loadingAddBonus"
          variant="success"
          class="ml-2 font-weight-bold w-100 text-nowrap"
        >
          <Spinner v-if="loadingAddBonus" />
          <template v-else> APPLY BONUS CASH </template>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BButton, BModal, BFormGroup, BFormInput } from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      amountBonus: null,
      bonusExpiredDays: 3,
    };
  },
  computed: {
    ...mapState("user/bonus", ["loadingAddBonus"]),
  },
  methods: {
    ...mapActions({
      addBonusForUser: "user/bonus/addBonusForUser",
      getAvailableBonus: "user/bonus/getAvailableBonus",
    }),
    closeModal() {
      this.$bvModal.hide("bonus-cash-modal");
    },
    handleCloseModal() {
      this.$bvModal.hide("bonus-cash-modal");
      this.amountBonus = null;
      this.bonusExpiredDays = 3;
    },
    async handleApplyBonus() {
      if (!this.amountBonus || !this.bonusExpiredDays) {
        this.$toast.error("Please enter all fields");
        return;
      }
      const res = await this.addBonusForUser({
        userIds: [this.$route.params.id],
        amount: this.amountBonus,
        bonusExpiredDays: this.bonusExpiredDays,
        name: "Direct offer",
        openDate: new Date().toISOString(),
        type: "direct",
        description: "Direct offer by admin",
      });

      if (res) {
        this.$toast.success("Add bonus successfully");
        this.handleCloseModal();
        await this.getAvailableBonus(this.$router.currentRoute.params.id);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dollar-icon {
  background: #e6f9ed;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
</style>
